import React from 'react';
import * as DiagnosticsService from '@modules/diagnostics/service';
import * as TE from 'fp-ts/TaskEither';
import { pipe } from 'fp-ts/function';
import { NextPageWithLayout } from 'next';
import { getPageInitialProps, HttpResult } from '@core/http';
import { sequenceS } from 'fp-ts/Apply';
import { getStringQuery, queryToHttpTask } from '@shared/utils/queries';
import { renderHttpResult } from '@shared/utils/render';
import Resolved from '@modules/diagnostics/Resolved';
import { Diagnostic } from '@modules/diagnostics/model';

interface ResolvedPageProps {
  diagnostic: Diagnostic;
  answerId: string;
}

const ResolvedPage: NextPageWithLayout<HttpResult<ResolvedPageProps>> = res =>
  renderHttpResult(res, ({ diagnostic, answerId }) => <Resolved diagnostic={diagnostic} answerId={answerId} />);

ResolvedPage.getLayoutProps = () => ({ headerLight: true });

ResolvedPage.getInitialProps = getPageInitialProps(ctx =>
  pipe(
    sequenceS(TE.ApplyPar)({
      diagnosticNumber: queryToHttpTask(getStringQuery(ctx.query, 'diagnostic_number')),
      answerId: queryToHttpTask(getStringQuery(ctx.query, 'answer_id')),
    }),
    TE.chain(({ diagnosticNumber, answerId }) =>
      sequenceS(TE.ApplyPar)({
        diagnostic: DiagnosticsService.getDiagnosticsDetail(diagnosticNumber),
        answerId: TE.right(answerId),
      }),
    ),
  ),
);

export default ResolvedPage;
